const LOG_LEVELS = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
};

function getOverrideLogLevel() {
  try {
    const val = localStorage.getItem('LOG_LEVEL_OVERRIDE');
    if (!val) return null;
    const upper = val.toUpperCase();
    return LOG_LEVELS[upper as keyof typeof LOG_LEVELS] ?? null;
  } catch {
    return null;
  }
}

const DEFAULT_LOG_LEVEL = import.meta.env.PROD ? LOG_LEVELS.ERROR : LOG_LEVELS.DEBUG;

const CURRENT_LOG_LEVEL = getOverrideLogLevel() ?? DEFAULT_LOG_LEVEL;

export class Logger {
  static debug(message: any, ...args: any[]) {
    if (CURRENT_LOG_LEVEL <= LOG_LEVELS.DEBUG) {
      console.debug(`[DEBUG] ${message}`, ...args);
    }
  }

  static info(message: any, ...args: any[]) {
    if (CURRENT_LOG_LEVEL <= LOG_LEVELS.INFO) {
      console.info(`[INFO] ${message}`, ...args);
    }
  }

  static warn(message: any, ...args: any[]) {
    if (CURRENT_LOG_LEVEL <= LOG_LEVELS.WARN) {
      console.warn(`[WARN] ${message}`, ...args);
    }
  }

  static error(message: any, ...args: any[]) {
    if (CURRENT_LOG_LEVEL <= LOG_LEVELS.ERROR) {
      console.error(`[ERROR] ${message}`, ...args);
    }
  }

  static setOverride(levelName: string) {
    if (!LOG_LEVELS[levelName as keyof typeof LOG_LEVELS]) return;
    localStorage.setItem('LOG_LEVEL_OVERRIDE', levelName);
    window.location.reload();
  }
}
